import React from 'react';
import { withRouter } from 'react-router-dom';
import {
    List,
    ListItem,
    Box,
    Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

const useStyles = makeStyles(() => ({
    listItem: {
        padding: '8px 16px 8px 16px !important',
        marginBottom: '8px !important',
        border: '1px solid #ebedf8 !important',
        borderRadius: '8px !important',
    },
    listItemHeader: {
        border: '0px !important',
        marginBottom: '8px !important',
        color: '#525050 !important',
        fontWeight: 'bold !important',
    },
}));

const StageChip = ({ stage }) => {
    const colorMap = {
        LEAD_UPLOADED:    '#f5a623',
        APP_DOWNLOADED:   '#7b61ff',
        KYC_VERIFIED:     '#2196f3',
        JOINING_FEE_PAID: '#4caf50',
        ID_CREATED:       '#00bcd4',
        STORE_VISIT_DONE: '#9c27b0',
        FOD_DONE:         '#e91e63',
    };
    const labelMap = {
        LEAD_UPLOADED:    'Lead Uploaded',
        APP_DOWNLOADED:   'App Downloaded',
        KYC_VERIFIED:     'KYC Verified',
        JOINING_FEE_PAID: 'Joining Fee Paid',
        ID_CREATED:       'ID Created',
        STORE_VISIT_DONE: 'Store Visit Done',
        FOD_DONE:         'FOD Done',
    };
    if (!stage) return null;
    return (
        <Typography
            style={{
                display: 'inline-block',
                fontSize: '11px',
                fontWeight: 600,
                padding: '2px 8px',
                borderRadius: '12px',
                backgroundColor: colorMap[stage] ?? '#ebedf8',
                color: '#fff',
                marginTop: 4,
                whiteSpace: 'nowrap',
            }}
        >
            {labelMap[stage] ?? stage}
        </Typography>
    );
};

function AgencyHireItem({ data }) {
    const classes = useStyles();

    return (
        <Box className="hire-item">
            <List component="nav">
                <ListItem className={classes.listItemHeader}>
                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: '100%',
                        }}
                    >
                        <Box style={{ flex: '0 0 17%' }}>Name</Box>
                        <Box style={{ flex: '0 0 12%' }}>Phone Number</Box>
                        <Box style={{ flex: '0 0 16%' }}>Lead Stage</Box>
                        <Box style={{ flex: '0 0 12%' }}>Referral Status</Box>
                        <Box style={{ flex: '0 0 10%' }}>City</Box>
                        <Box style={{ flex: '0 0 10%' }}>Zone</Box>
                        <Box style={{ flex: '0 0 12%' }}>Store</Box>
                        <Box style={{ flex: '1 1 0' }}>Uploaded At</Box>
                    </Box>
                </ListItem>

                {data?.map((val, index) => (
                    <ListItem
                        key={val.referralMappingId ?? index}
                        className={classes.listItem}
                        style={
                            index % 2
                                ? { backgroundColor: 'rgba(241, 243, 246, 1)' }
                                : {}
                        }
                    >
                        <Box
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                width: '100%',
                                alignItems: 'center',
                            }}
                        >
                            {/* Name */}
                            <Box style={{ flex: '0 0 17%', paddingRight: 8 }}>
                                <Typography style={{ fontWeight: 600, wordBreak: 'break-word' }}>
                                    {val.name ?? '-'}
                                </Typography>
                            </Box>

                            {/* Phone Number */}
                            <Box style={{ flex: '0 0 12%', paddingRight: 8 }}>
                                <Typography style={{ fontSize: '13px' }}>
                                    {val.contactNumber ?? '-'}
                                </Typography>
                            </Box>

                            {/* Stage — sub_status funnel chip */}
                            <Box style={{ flex: '0 0 16%', paddingRight: 8 }}>
                                <StageChip stage={val.subStatus} />
                            </Box>

                            {/* Referral Status */}
                            <Box style={{ flex: '0 0 12%', paddingRight: 8 }}>
                                <Typography style={{ fontWeight: 500, fontSize: '13px', wordBreak: 'break-word' }}>
                                    {val.referralStatus ?? '-'}
                                </Typography>
                            </Box>

                            <Box style={{ flex: '0 0 10%', paddingRight: 8 }}>
                                <Typography style={{ fontSize: '13px', wordBreak: 'break-word' }}>
                                    {val.cityName ?? '-'}
                                </Typography>
                            </Box>

                            <Box style={{ flex: '0 0 10%', paddingRight: 8 }}>
                                <Typography style={{ fontSize: '13px', wordBreak: 'break-word' }}>
                                    {val.zoneName ?? '-'}
                                </Typography>
                            </Box>

                            {/* Store */}
                            <Box style={{ flex: '0 0 12%', paddingRight: 8 }}>
                                <Typography style={{ fontSize: '13px', wordBreak: 'break-word' }}>
                                    {val.storeName ?? '-'}
                                </Typography>
                            </Box>

                            {/* Uploaded At */}
                            <Box style={{ flex: '1 1 0' }}>
                                <Typography style={{ fontSize: '12px' }}>
                                    {val.leadUploadedAt
                                        ? moment(val.leadUploadedAt).format('DD-MMM-YYYY')
                                        : '-'}
                                </Typography>
                                <Typography style={{ fontSize: '11px', color: '#888' }}>
                                    {val.leadUploadedAt
                                        ? moment(val.leadUploadedAt).format('hh:mm A')
                                        : ''}
                                </Typography>
                            </Box>
                        </Box>
                    </ListItem>
                ))}
            </List>
        </Box>
    );
}

export default withRouter(AgencyHireItem);
